<template>
  <div class="w-full">
    <vx-tooltip :text="$t('add_new_vendor') | capitalize">
      <vs-button
        color="success"
        icon-pack="feather"
        icon="icon-user-plus"
        type="filled"
        @click="open"
        class="w-full"
      >
      {{ $tc('new') | capitalize }}
      </vs-button>
    </vx-tooltip>
    <vs-popup-custom
      :title="$t('add_new_vendor') | capitalize"
      color="danger"
      :buttonCloseHidden="true"
      :active.sync="active"
      :persistent="true"
    >
      <div id="add-vendor-loading" class="vs-con-loading__container">
        <div class="px-2">
          <vs-row class="mb-2">
            <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
              <span>{{ $tc('type', 1) | capitalize }}</span>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="9" vs-lg="9">
              <v-select
                v-model="form.type"
                :options="types"
                class="w-full"
                :reduce="(item) => item.id"
                label="name"
                :clearable="false"
                disabled
              />
            </vs-col>
          </vs-row>
          <vs-row class="mb-2">
            <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
              <span>{{ $t('name') | capitalize }}</span>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="9" vs-lg="9">
              <vs-input
                :placeholder="$t('name') | capitalize"
                class="w-full"
                v-model="form.name"
              />
            </vs-col>
          </vs-row>
          <vs-row class="mb-2">
            <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
              <span>{{ $t('rfc') | capitalize }}</span>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="9" vs-lg="9">
              <vs-input
                :placeholder="$t('rfc') | capitalize"
                class="w-full"
                v-model="form.rfc"
                @input="
                  (v) => {
                    form.rfc = v.toUpperCase()
                  }
                "
              />
            </vs-col>
          </vs-row>
          <vs-row class="mb-2">
            <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
              <span>{{ $t('email') | capitalize }}</span>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="9" vs-lg="9">
              <vs-input
                :placeholder="$t('email') | capitalize"
                class="w-full"
                v-model="form.email"
              />
            </vs-col>
          </vs-row>

          <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-xs="12"
              vs-sm="3"
              vs-lg="3"
            >
              <vs-button class="w-full mx-2" type="border" @click="close">
                {{ $t('cancel') | capitalize }}
              </vs-button>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-xs="12"
              vs-sm="3"
              vs-lg="3"
            >
              <vs-button
                class="w-full mx-2"
                type="filled"
                color="primary"
                :disabled="disabledSubmit"
                @click="handleSubmit"
              >
                {{ $t('submit') | capitalize }}
              </vs-button>
            </vs-col>
          </vs-row>
        </div>
      </div>
    </vs-popup-custom>
  </div>
</template>

<script>
import VsPopupCustom from '@/views/components/modals/VsPopupCustom.vue'
import loading from '@/mixins/Loading'
import vSelect from 'vue-select'
import request from '../request'

export default {
  components: {
    VsPopupCustom,
    'v-select': vSelect,
  },
  computed: {
    disabledSubmit() {
      return this.rfc === '' || this.name === '' || this.email === ''
    },
  },
  data() {
    return {
      active: false,
      types: [],
      form: {
        type: '',
        name: '',
        rfc: '',
        email: '',
      },
    }
  },
  methods: {
    open() {
      Object.assign(this.form, { type: this.types[3].id, name: '', rfc: '', email: '' })
      this.active = true
    },
    close() {
      this.active = false
    },
    getTypes() {
      this.openLoading('add-vendor-loading')
      request
        .getTypes()
        .then((response) => {
          this.types = [...response.data.types]
          this.form.type = this.types[0].id
          this.closeLoading('add-vendor-loading')
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.closeLoading('add-vendor-loading')
        })
    },
    handleSubmit() {
      this.openLoading('add-vendor-loading')
      request
        .addVendor(this.form)
        .then((res) => {
          this.closeLoading('add-vendor-loading')
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Vendor Saved',
          })
          this.close()
          this.$emit('success', res.data.item)
        })
        .catch((res) => {
          this.showValidationErrors(res)
          this.closeLoading('add-vendor-loading')
        })
    },
  },
  mixins: [loading],
  mounted() {
    this.getTypes()
  },
}
</script>

<style>
.select-h > .vs__dropdown-menu {
  height: 50px;
}
.popup-custom-h-400 {
  height: 290px;
}
</style>